import { useEffect } from "react";

import { useRouter } from "next/router";

/**
 * Articles on the read page that exist in alexandria will redirect to the view page
 * with the "redirectPath" param. If the content doesn't exist, we'll redirect back to the read page
 * with a "preventRedirect" query param to avoid redirect loop.
 * @param {LangstonContentResponse | null | undefined} content - content object from useLangstonContentGet()
 */
const useRedirectToReadPageIfContentDoesNotExist = (
  content,
  contentRequestError,
) => {
  const router = useRouter();
  const { pathname, query } = router;
  const { redirectUrl: readPageRedirectUrl } = query;

  const contentError = contentRequestError?.statusCode;
  const isContentLoading = !content && !contentError;

  useEffect(() => {
    if (!readPageRedirectUrl || isContentLoading) return;

    if (content) {
      delete router.query.redirectUrl;
      router.replace({ pathname, query }, null, { shallow: true });
    } else if (contentError) {
      const readPageUrl = new URL(decodeURIComponent(readPageRedirectUrl));
      readPageUrl.searchParams.append("preventRedirect", "true");
      window.location.href = `${readPageUrl}`;
    }
  }, [content, contentRequestError]);
};

export default useRedirectToReadPageIfContentDoesNotExist;
